import { ICompany } from '../types/company.type';
import $http from '../services/AxiosInstance';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class CompaniesRepository {
  static async getCompanies(allCompanies: boolean = false) {
    try {
      const response = await $http.get('/companies', {params: allCompanies ? {flag: 'all'} : {}});
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getCompaniesPro(params: Params = {}) {
    try {
      let url = `/companies/pro`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createCompany(data: ICompany): Promise<ICompany> {
    try {
      const response = await $http.post('/companies', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateCompany(data: ICompany): Promise<ICompany> {
    try {
      const response = await $http.patch(`/companies/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteCompany(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/companies/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreCompany(id: number): Promise<number> {
    try {
      const response = await $http.post(`/companies/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default CompaniesRepository;
